import { API_COMPOSER_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { type ReactElement } from 'react'
import type { Error } from '@eggplant/types'

interface Props {
  onError?: (error: Error) => void
  onSuccess?: () => void
  children?: () => ReactElement
  shortErrorMessage?: string
  id: string
}

const UnlinkComposerAssets = ({
  shortErrorMessage,
  onError,
  onSuccess,
  children,
  id
}: Props) => {
  const url = `${API_COMPOSER_SERVICE}/assets/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onError={onError}
      onSuccess={onSuccess}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default UnlinkComposerAssets
